import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  Grid,
  Box,
  TableContainer,
  Table,
  TableBody,
  useTheme,
} from "@mui/material";
import {
  TABLE_HEAD_PORTFOLIO_LONG,
  TABLE_HEAD_PORTFOLIO_SHORT,
  applySortFilter,
  getComparator,
} from "../../../component/Methods";
import PositionTable from "../PositionTable";
import VantageListHead from "../../../component/ListHead/VantageListHead";

const PositionPopUp = (props) => {
  const theme = useTheme();
  const { title, open, setOpen, data, positionType } = props;

  const [filterName, setFilterName] = useState("");
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");
  const [filteredData, setFilteredData] = useState([]);

  const tableHead = positionType === "long" ? TABLE_HEAD_PORTFOLIO_LONG : TABLE_HEAD_PORTFOLIO_SHORT;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    if (data) {
      const filtered = applySortFilter(
        data,
        getComparator(order, orderBy),
        filterName
      );
      setFilteredData(filtered);
    } else {
      setFilteredData([]);
    }
  }, [data, order, orderBy, filterName]);

  useEffect(() => {
    if (open && data) {
      const filtered = applySortFilter(
        data,
        getComparator(order, orderBy),
        filterName
      );
      setFilteredData(filtered);
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      onClose={handleClose}
      sx={{
        "& .css-1t1j96h-MuiPaper-root-MuiDialog-paper": {
          minWidth: "500px",
          marginLeft: "200px",
        },
      }}
    >
      <DialogTitle>
        <Typography
          variant="h6"
          component="div"
          align="left"
          style={{ flexGrow: 1, fontSize: "20px" }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            border: `1px solid ${theme.palette.lightGrey.tableHeader}`,
            borderRadius: "4px",
          }}
        >
          <Grid item xs={6} md={6}>
            <TableContainer>
              <Table
                size="small"
                stickyHeader
                aria-label="a dense table"
                sx={{
                  height: "max-content",
                  maxHeight: "55px",
                  borderCllapse: "collapse",
                }}
              >
                <VantageListHead
                  headLabel={tableHead}
                  noStatus={true}
                  title={true}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                />

                <TableBody>
                  {filteredData?.map((row, i) => (
                    <PositionTable 
                      row={row} 
                      key={i} 
                      visible={true} 
                      positionType={positionType} 
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Box>

        <Grid
          item
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "5px",
          }}
        >
          <Button
            variant="contained"
            sx={{
              width: "10%",
              background: "#B2BEB5",
              color: "#000",
              "&:hover": { background: "#808080" },
            }}
            onClick={handleClose}
          >
            CLOSE
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default PositionPopUp;

